import { render, staticRenderFns } from "./add_interface_dialog.vue?vue&type=template&id=6225da16&scoped=true"
import script from "./add_interface_dialog.vue?vue&type=script&lang=js"
export * from "./add_interface_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_interface_dialog.vue?vue&type=style&index=0&id=6225da16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6225da16",
  null
  
)

export default component.exports